// src/data/formData.js

// States
export const states = ["ALBERTA", "BRITISH COLUMBIA", "MANITOBA", "NEW BRUNSWICK", "NEWFOUNDLAND AND LABRADOR", "NOVA SCOTIA", "NORTHWEST TERRITORIES", "NUNAVUT", "ONTARIO", "PRINCE EDWARD ISLAND", "QUEBEC", "SASKATCHEWAN", "YUKON"];

// Property types
export const propertyType = ["Common Elements Condo", "Condo Apartment", "Condo Townhouse", "Co-Op Apartment", "Co-Ownership Apartment",
    "Detached Condo", "Leasehold Condo", "Locker", "Parking Space", "Phased Condo", "Semi-Detached Condo", "Timeshare", "Vacant Land Condo", "Other"];

export const propertySubType = [
  "Studio Flat",
  "Single Family",
  "Multifamily",
  "Condo / Apartment",
  "Mobile Home",
  "Mixed-Use",
  "Land",
  "Others",
  "Predabricated",
  "Unsecured",
  "Townhome",
  "Co-Op",
];
 export const OwnerShip  = ["Any", "Freehold", "Condo/Strata", "Timeshare/Fractional", "Leasehold"];
 export const timing = ["10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "11:55PM"];
 export const  FarmType = ["Animal", "Cash Crop", "Hobby Farm", "Market Gardening", "Nursery", "GreenHouse", "Orchard", "Vineyard", "Feed Lot", "Boarding", "Mixed"];
export const occupanyStatus = ["Occupied", "Vacant"];
export const ParkingType = ["Boat House", "Concreate", "Heated Garage", "Attached Garaged", "Integrated Garage", "Detached Garage", "Garage", "Carpot", "Underground", "Indoor", "Open", "Covered", "Parking Pad", "Paved Yard", "Additional Parking"];
export const zoningType = ["Commercial Retail", "Commercial Office", "Commercial Mixed", "Industrial", "Industrial-Light", "Industrial-Medium", "Industrial-Heavy", "Resisdential-Low Density", "Resisdential-Medium Density", "Resisdential-High Density", "Institutional", "Agricultural", "Recreational", "Other"];
// Lender IDs
export const lenderId = [
  "BANK0100",
  "COB0456",
  "FLAG0104",
  "GEFIN0101",
  "REVCA0102",
  "SHELL0103",
  "WFB0123",
];
// Garage
export const Garage = ["Yes", "No"];

// Years 1800 to 2025
export const years = Array.from({ length: 2025 - 1800 + 1 }, (_, i) => 1800 + i);

// Bedrooms 0 to 31
export const bedrooms = Array.from({ length: 32 }, (_, i) => i.toString());

// HOA
export const HOA = ["Monthly", "Quarterly", "Half yearly", "Yearly"];

// Half bathrooms 0 to 31
export const halfBathrooms = Array.from({ length: 32 }, (_, i) => i);

// Heating types
export const heating = ["Coal", "Electric", "Gas", "Other"];

// Fireplaces 0 to 4
export const fireplaces = Array.from({ length: 5 }, (_, i) => i);

// Basement types
export const basementType = ["None", "Partial", "Full"];

// Total rooms 0 to 60
export const totalRooms = Array.from({ length: 61 }, (_, i) => i);


// filters states.. . ...
export const propertyTypes = [
    "Any",
    "Residential",
    "Condo/Strata",
    "Vacant Land",
    "Recreational",
    "Multi Family",
    "Agriculture",
    "Parking",
  ];

  export const priceList = [
  // 25,000 to 1,000,000 (step 25,000)
  "25,000","50,000","75,000","100,000","125,000","150,000","175,000","200,000",
  "225,000","250,000","275,000","300,000","325,000","350,000","375,000","400,000",
  "425,000","450,000","475,000","500,000","525,000","550,000","575,000","600,000",
  "625,000","650,000","675,000","700,000","725,000","750,000","775,000","800,000",
  "825,000","850,000","875,000","900,000","925,000","950,000","975,000","1,000,000",

  // 1,100,000 to 2,000,000 (step 100,000)
  "1,100,000","1,200,000","1,300,000","1,400,000","1,500,000","1,600,000",
  "1,700,000","1,800,000","1,900,000","2,000,000",

  // 2,500,000 to 10,000,000 (step 500,000)
  "2,500,000","3,000,000","3,500,000","4,000,000","4,500,000","5,000,000",
  "5,500,000","6,000,000","6,500,000","7,000,000","7,500,000","8,000,000",
  "8,500,000","9,000,000","9,500,000","10,000,000",

  // Last two values
  "15,000,000","20,000,000"
];

export const bedsList = ["Any", "1", "2", "3", "4", "5"];
export const bathsList = ["Any", "1", "2", "3", "4", "5"];
export const squareFootageList = [
  "500",
  "750",
  "1000",
  "1200",
  "1500",
  "1750",
  "2000",
  "2250",
  "2500",
  "2750",
  "3000",
  "3500",
  "4000",
  "4500",
  "5000",
  "7500",
  "10000",
];
export const buildingTypeList = [
  "House",
  "Row/Townhouse",
  "Apartment",
  "Duplex",
  "Triplex",
  "Fourplex",
  "Garden Home",
  "Mobile Home",
  "Manufactured Home/Mobile",
  "Special Purpose",
  "Residential Commercial Mix",
  "Manufactured Home",
  "Commercial Apartment",
  "Two Apartment House",
  "Park Model Mobile Home",
  "Floathome",
];
export const storeysList = ["1", "2", "3", "4", "5", "6", "10", "15", "20", "50"];
export const ownershipTitleList = ["Any", "Freehold", "Condo/Strata", "Timeshare/Fractional", "Leasehold"];
export const landSizeList = [
  "0.25 acres",
  "0.5 acres",
  "1 acres",
  "2 acres",
  "5 acres",
  "10 acres",
  "50 acres",
  "100 acres",
  "200 acres",
  "300 acres",
  "400 acres",
  "500 acres",
  "1000 acres"
];
export const maintenanceFeeMonthlyList = [
  "200", "300", "400", "500", "600", "700", "800", "900", "1,000", "1,500", "2,000"
];
export const propertyTaxYearlyList = [
  "250", "500", "1,000", "2,000", "3,000", "4,000", "5,000", "6,000", "8,000", "10,000", "20,000"
];
export const yearBuiltList = Array.from({ length: 2025 - 1900 + 1 }, (_, i) =>
  (1900 + i).toString()
);
export const farmList = [
  "Animal",
  "Cash Crop",
  "Hobby Farm",
  "Market Gardening",
  "Nursery",
  "GreenHouse",
  "Orchard",
  "Vineyard",
  "Feed Lot",
  "Boarding",
  "Mixed",
];
export const parkingList = [
  "Boat House",
  "Concreate",
  "Heated Garage",
  "Attached Garage",
  "Integrated Garage",
  "Detached Garage",
  "Garage",
  "Carport",
  "Underground",
  "Indoor",
  "Open",
  "Covered",
  "Parking Pad",
  "Paved Yard",
  "Additional Parking",
];
export const buildingStyleList = ["Detached", "Semi Detached", "Attached", "Link"];
export const numberOfUnitsList = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
export const exteriorBuildingSizeList = [
  "Any",
  "0-5,000 sqft",
  "5,001-10,000 sqft",
  "10,001-15,000 sqft",
  "15,001-20,000 sqft",
  "20,001-25,000 sqft",
  "25,001-30,000 sqft",
  "30,001-35,000 sqft",
  "35,001-40,000 sqft",
  "40,001-45,000 sqft",
  "45,001-50,000 sqft",
  "50,001-75,000 sqft",
  "75,001-100,000 sqft",
  "100,001-150,000 sqft",
  "150,001-200,000 sqft",
  "200,001-250,000 sqft",
  "Over 250,000 sqft"
];

export const zoningTypeList = [
  "Commercial Retail",
  "Commercial Office",
  "Commercial Mixed",
  "Industrial",
  "Industrial-Light",
  "Industrial-Medium",
  "Industrial-Heavy",
  "Residential-Low Density",
  "Residential-Medium Density",
  "Residential-High Density",
  "Institutional",
  "Agricultural",
  "Recreational",
  "Other"
];

// add property ...
// Property category for dropdown in Add Property section
export const propertyCategory = [
  "Bank Owned",
  "Non Bank Owned"
];
// Building styles for dropdown in Add Property section
export const buildingStyle = [
  "Detached",
  "Semi-Deteched",
  "Attached",
  "Link"

];
// Building types for dropdown in Add Property section
export const buildingTypes = [
  "House",
  "Row/Townhouse",
  "Apartment",
  "Duplex",
  "Triplex",
  "Fourplex",
  "Garden Home",
  "Mobile Home",
  "Manufactured Home/Mobile",
  "Special Purpose",
  "Residential Commercial Mix",
  "Manufactured Home",
  "Commercial Apartment",
  "Two Apartment House",
  "Park Model Mobile Home",
  "Floathome"
];
// Property names for dropdown in Add Property section
export const propertyNames = [
  "Apartment",
  "Condominium",
  "House",
  "Townhouse",
  "Duplex",
  "Triplex",
  "Penthouse",
  "Studio",
  "Loft",
  "Villa",
  "Farmhouse",
  "Cottage",
  "Bungalow",
  "Mobile Home",
  "Manufactured Home",
  "Office Space",
  "Retail Shop",
  "Showroom",
  "Warehouse",
  "Industrial Property",
  "Co-working Space",
  "Hotel",
  "Motel",
  "Guest House",
  "Mixed-use Building",
  "Residential Plot",
  "Agricultural Land",
  "Farmland",
  "Commercial Land",
  "Industrial Land",
  "Recreational Land",
  "Special Purpose Property"
];
// src/data/formData.js

export const  STATES = [
    "ALBERTA", "BRITISH COLUMBIA", "MANITOBA", "NEW BRUNSWICK", "NEWFOUNDLAND AND LABRADOR", "NOVA SCOTIA",
    "NORTHWEST TERRITORIES", "NUNAVUT", "ONTARIO", "PRINCE EDWARD ISLAND", "QUEBEC", "SASKATCHEWAN", "YUKON"
];

export const  architectural_style = ["2-Storey", "3-Storey", "Apartment", "Bachelor/Studio", "Bungaloft", "Bungalow", "Loft", "Multi-Level", "Stacked Townhouse", "Other"]

export const  province =[
    "ALBERTA", "BRITISH COLUMBIA", "MANITOBA", "NEW BRUNSWICK", "NEWFOUNDLAND AND LABRADOR", "NOVA SCOTIA",
    "NORTHWEST TERRITORIES", "NUNAVUT", "ONTARIO", "PRINCE EDWARD ISLAND", "QUEBEC", "SASKATCHEWAN", "YUKON"
]
export const fireplaced = [ "2 Way", "Acorn Stove", "Brick", "Closed", "Electric", "Fireplace", "Floor to Ceiling",
    "Franklin Stove", "Gas", "Imitation", "Insert", "Marble", "Pellet", "Roughed-in", "Stone", "Wall-to-Wall",
    "Wood Stove", "Zero Clearance"]

export const exterior = ["Aluminum Siding", "Board & Batten", "Brick", "Brick Front", "Concrete",
    "Insulbrick", "Log", "Metal/Steel Siding", "Shingle", "Stone", "Stucco (Plaster)", "Vinyl Siding", "Wood", "Other"]

export const heatings = ["Electric", "Gas", "Ground Source", "Oil", "Other", "Propane", "Solar", "Wood"]

export const cooling = ["Central Air", "None", "Wall Unit(s)", "Window Unit(s)", "Other"]

export const flooring = ["Bamboo Floor", "Broadloom", "Ceramic", "Concrete", "Cork Floor", "Cushion", "Granite",
    "Hardwood", "Heated Floor", "Laminate", "Limestone Flooring", "Linoleum", "Marble", "Parquet", "Pegged",
    "Plank Floor", "Porcelain", "Raised", "Slate Flooring", "Stone Floor", "Tile", "Tumbled Marble", "Wood"]

export const Parking = ["Facilities", "Mutual", "None", "Other", "Private", "Surface", "Underground"];

